export const ARCHIVED_ISSUES_REPORT = 'archivedIssuesReport';
export const CREATE_NEW_USER = 'createNewUser';
export const DELETE_USER = 'deleteSelectedUser';
export const UPDATE_USER_PASSWORD = 'updateSelectedUserPassword';
export const GET_USERS = 'getUsers';
export const UPDATE_ISSUE = 'updateIssue';
